import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-1.jpg'
import _imports_1 from '@/assets/images/user-2.jpg'
import _imports_2 from '@/assets/images/user-3.jpg'
import _imports_3 from '@/assets/images/user-4.jpg'
import _imports_4 from '@/assets/images/user-5.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "default-table-area style-two shipment-list" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[46] || (_cache[46] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 p-4\"><h3 class=\"mb-0\">Shipment List</h3><div class=\"d-flex flex-wrap gap-2 gap-sm-3 align-items-center\"><form class=\"position-relative table-src-form me-0\"><input type=\"text\" class=\"form-control\" placeholder=\"Search here\"><i class=\"material-symbols-outlined position-absolute top-50 start-0 translate-middle-y\">search</i></form><select class=\"form-select month-select form-control w-135 bg-border-color border-color bg-transparent\" aria-label=\"Default select example\"><option selected>Last 30 days</option><option value=\"1\">Last 90 days</option><option value=\"1\">Last 1 year</option></select></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[45] || (_cache[45] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1" }, "Shipment ID")
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "Customer Name"),
                _createElementVNode("th", { scope: "col" }, "Products"),
                _createElementVNode("th", { scope: "col" }, "Cost"),
                _createElementVNode("th", { scope: "col" }, "Ship Date"),
                _createElementVNode("th", { scope: "col" }, "Origin"),
                _createElementVNode("th", { scope: "col" }, "Shipment Method"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#0015")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-30 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "David Farrior")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Toys", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-danger" }, "$50,000", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "2024-10-01", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "New York, USA", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Air", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-success bg-opacity-10 text-success p-2 fs-12 fw-normal" }, " Delivered ")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "dropdown action-opt" }, [
                    _createElementVNode("button", {
                      class: "btn bg-transparent p-0",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("i", { "data-feather": "more-horizontal" })
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "edit" }),
                          _createTextVNode(" Edit ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "eye" }),
                          _createTextVNode(" View ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "trash" }),
                          _createTextVNode(" Delete ")
                        ])
                      ])
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#0099")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-30 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Leslie Yawn")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("td", null, "Sports", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", { class: "text-danger" }, "$1,20,000", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", null, "2024-09-28", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", null, "Shanghai, China", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("td", null, "Sea", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal" }, " In Transit ")
                ], -1)),
                _cache[17] || (_cache[17] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "dropdown action-opt" }, [
                    _createElementVNode("button", {
                      class: "btn bg-transparent p-0",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("i", { "data-feather": "more-horizontal" })
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "edit" }),
                          _createTextVNode(" Edit ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "eye" }),
                          _createTextVNode(" View ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "trash" }),
                          _createTextVNode(" Delete ")
                        ])
                      ])
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[19] || (_cache[19] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#0145")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-30 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Willie Wood")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("td", null, "Fashion", -1)),
                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "text-danger" }, "$50,000", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("td", null, "2024-09-25", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", null, "Berlin, Germany", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("td", null, "Road", -1)),
                _cache[25] || (_cache[25] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal" }, " On The Way ")
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "dropdown action-opt" }, [
                    _createElementVNode("button", {
                      class: "btn bg-transparent p-0",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("i", { "data-feather": "more-horizontal" })
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "edit" }),
                          _createTextVNode(" Edit ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "eye" }),
                          _createTextVNode(" View ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "trash" }),
                          _createTextVNode(" Delete ")
                        ])
                      ])
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[28] || (_cache[28] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#0247")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-30 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Jill Caldera")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("td", null, "Food", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("td", { class: "text-danger" }, "$80,000", -1)),
                _cache[31] || (_cache[31] = _createElementVNode("td", null, "2024-09-22", -1)),
                _cache[32] || (_cache[32] = _createElementVNode("td", null, "Tokyo, Japan", -1)),
                _cache[33] || (_cache[33] = _createElementVNode("td", null, "Air", -1)),
                _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-success bg-opacity-10 text-success p-2 fs-12 fw-normal" }, "Delivered")
                ], -1)),
                _cache[35] || (_cache[35] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "dropdown action-opt" }, [
                    _createElementVNode("button", {
                      class: "btn bg-transparent p-0",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("i", { "data-feather": "more-horizontal" })
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "edit" }),
                          _createTextVNode(" Edit ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "eye" }),
                          _createTextVNode(" View ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "trash" }),
                          _createTextVNode(" Delete ")
                        ])
                      ])
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[37] || (_cache[37] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "form-check" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault2"
                      })
                    ]),
                    _createElementVNode("span", { class: "ms-1 text-secondary" }, "#0299")
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_RouterLink, {
                    to: "/my-profile",
                    class: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-30 rounded-circle",
                        alt: "user"
                      }, null, -1),
                      _createElementVNode("div", { class: "ms-2" }, [
                        _createElementVNode("h6", { class: "fw-medium fs-14" }, "Bill Mitchell")
                      ], -1)
                    ])),
                    _: 1
                  })
                ]),
                _cache[38] || (_cache[38] = _createElementVNode("td", null, "Electronics", -1)),
                _cache[39] || (_cache[39] = _createElementVNode("td", { class: "text-danger" }, "$1,50,000", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("td", null, "2024-09-20", -1)),
                _cache[41] || (_cache[41] = _createElementVNode("td", null, "Madrid, Spain", -1)),
                _cache[42] || (_cache[42] = _createElementVNode("td", null, "Sea", -1)),
                _cache[43] || (_cache[43] = _createElementVNode("td", null, [
                  _createElementVNode("span", { class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal" }, " Pending ")
                ], -1)),
                _cache[44] || (_cache[44] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "dropdown action-opt" }, [
                    _createElementVNode("button", {
                      class: "btn bg-transparent p-0",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("i", { "data-feather": "more-horizontal" })
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "edit" }),
                          _createTextVNode(" Edit ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "eye" }),
                          _createTextVNode(" View ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "trash" }),
                          _createTextVNode(" Delete ")
                        ])
                      ])
                    ])
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Pagination, {
          items: "05",
          total: "30",
          class: "p-4"
        })
      ])
    ])
  ]))
}